export default __webpack_public_path__ + "static/media/element_103.c2b34aa3.webp";